// extracted by mini-css-extract-plugin
export var box = "_4i-2";
export var checkboxControl = "_4i-0";
export var checkboxRow = "_4i-a";
export var checked = "_4i-3";
export var descriptionSpacer = "_4i-c";
export var disabled = "_4i-4";
export var icon = "_4i-8";
export var input = "_4i-1";
export var labelSpacer = "_4i-b";
export var large = "_4i-7";
export var medium = "_4i-6";
export var small = "_4i-5";
export var text = "_4i-9";